<div class="input-wrapper">
  <input
    #inputEl
    class="form-control"
    type="text"
    [attr.placeholder]="placeholder"
    [attr.inputmode]="allowDecimal ? 'decimal' : 'numeric'"
    [attr.readonly]="readonly ? '' : null"
    [disabled]="disabled"
    [value]="display"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput($event)"
    (paste)="onPaste($event)"
  />

  <div
    class="arrows-container"
    *ngIf="!readonly && !disabled"
  >
    <button
      type="button"
      class="arrow-btn"
      [disabled]="disabled"
      (pointerdown)="onArrowPointerDown(1, $event)"
      aria-label="Increase"
    >
      ▲
    </button>
    <button
      type="button"
      class="arrow-btn"
      [disabled]="disabled"
      (pointerdown)="onArrowPointerDown(-1, $event)"
      aria-label="Decrease"
    >
      ▼
    </button>
  </div>
</div>
